module.exports = __webpack_public_path__ + "static/media/arts_8.bbe86f22.jpg";